//This is the functionality for the category
EMMY.checkout = {
  init: function () {
    var totalCost = _calculateTotal();
    if (typeof totalCost === "undefined") {
      totalCost = 0;
    }
    _totalZeroConfirmPay();


    $('.checkout-table').on('change', '.checkboxes input', function(e) {
        var totalCost = _calculateTotal();
        $('.total-due span').text(totalCost);
        _totalZeroConfirmPay();
    });

    $('.clickable span').on('click', function() {
      if($(this).hasClass('unselectall')) {
        var checkboxAction = false;
        _unCheckAllBoxes();
      } else {
        var checkboxAction = true;
        _checkAllBoxes();
      }

      $(this).parent().find('span').toggleClass('hide-me');
      var totalCost = _calculateTotal();
      $('.total-due span').text(totalCost);
      _totalZeroConfirmPay();
    })

    // Stop double click on checkout
    $('.finalize-button').on('click', function(e) {
      e.preventDefault();
      $(this).attr('disabled', true);
      $(this).closest('form').submit();
    });

  }
};

function _calculateTotal() {
  let totalCost = 0;
  $('.checkout-table tr').each(function() {
    if($(this).find('.checkbox').is(':checked')) {
      var costVal = parseFloat($(this).find('.cost span').text().replace(/,/g, ''));
      totalCost += costVal;
    }
  });
  return totalCost.toFixed(2);
}

function _totalZeroConfirmPay() {
  var boxesChecked = boxesChecker();
  var totalDue = parseFloat($('.total-due span').text());
  if (isNaN(totalDue)) { totalDue = '0.00'; }
  if ((totalDue == '0.00') && (boxesChecked)) {
    $('.info-table button.pay-button').hide();
    $('.info-table button.finalize-button').show();
    $('.total-due span').show();
  } else if ((totalDue == '0.00') && (!boxesChecked)) {
    $('.info-table button.finalize-button').hide();
    $('.info-table button.pay-button').hide();
    $('.total-due span').hide();
  } else {
    $('.info-table button.pay-button').show();
    $('.info-table button.finalize-button').hide();
    $('.total-due span').show();
  }
}


function boxesChecker() {
  var counter = 0;
  $('.paytable .checkbox').each(function(i,v) {
    if (v.checked) {
      counter++;
    }
  });
  if (counter > 0) {
    var boxesChecked = true;
  } else {
    var boxesChecked = false;
  }
  return boxesChecked;
}

function _unCheckAllBoxes() {
  $('.paytable .checkboxes input:checked').each(function(i,v) {
    $(this).prop('checked',false);
  });
}
function _checkAllBoxes() {
  $('.paytable .checkboxes input:not(:checked)').each(function(i,v) {
    $(this).prop('checked',true);
  });
}
